import { indexToGrade } from "../SchoolAdmin/translations";

const gradeToRank = Object.keys(indexToGrade)
    .sort((a, b) => Number(a) - Number(b))
    .reduce((acc, k, i) => {
        acc[indexToGrade[k]] = i;
        return acc;
    }, {});

const gradeRank = (g) => gradeToRank[g] ?? Number.POSITIVE_INFINITY; // unknown grades go last

export const byGradeThenCreator = (a, b) => {
    const gA = gradeRank(a.sharedGradeName ?? a.sharedMeta?.sharedGradeName);
    const gB = gradeRank(b.sharedGradeName ?? b.sharedMeta?.sharedGradeName);
    if (gA !== gB) return gA - gB;

    const nA = a.sharedMeta?.sharedGroupCreatorDisplayName || "";
    const nB = b.sharedMeta?.sharedGroupCreatorDisplayName || "";
    return nA.localeCompare(nB, undefined, { sensitivity: "base" });
};
